import React from 'react'
import { FormattedMessage } from 'react-intl'

export default class IsPositiveNumberValidator {
  constructor({ value }) {
    this.value = value
    this.errorMessage = <FormattedMessage id="invalid_positive_number_value" />
  }

  validate() {
    // eslint-disable-next-line no-restricted-globals
    if (isNaN(this.value) || this.value < 0) {
      return this.errorMessage
    }

    return null
  }
}
